import { isOtpCode as e } from "./validators.mjs";
const t = {
  validate: e,
  required: !0
};
export {
  t as FORM_OTP_DEFAULT_VALIDATION
};
//# sourceMappingURL=constants9.mjs.map
